import store from '@/store'
import localesService from '@/services/locales'

const loadingKeys = {
    fetchingLocales: 'fetching-locales',
}

export default {
    data () {
        return {
            browser_locale: window.navigator.language,
            i18Keys: '',
            langSelect: ''
        }
    },

    mounted () {
        this.fetchLocale()
    },

    computed: {
        isAuthenticated () {
            return store.getters['session/isAuthenticated']
        },

        locale () {
            return store.getters['locale/currentLocale']
        },
    },

    methods: {
        async fetchLocale () {
            this.loadingAdd(loadingKeys.fetchingLocales)

            let parameters = {}

            let response = await localesService.retrieve(parameters)

            if (response.status === 200) {
                for (let i = 0; i < response.data.results.length; i++) {
                    let parsed = JSON.parse(
                        response.data.results[i].definition
                    )
                    response.data.results[i].calendarPickerLocale =
                        parsed.calendarPickerLocale
                    response.data.results[i].definition = parsed.definition
                }
                this.i18Keys = response.data.results
                this.langSelect = this.locale
                store.commit('locale/setList', this.i18Keys)
            }

            this.loadingRemove(loadingKeys.fetchingLocales)
        },

        setFlag (langKey) {
            return langKey.slice(3).toLowerCase()
        },

        convertLang (langBrowser) {
            return langBrowser.substr(0, 2)
        }
    }
}